import { Fragment, useEffect, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { goalTypes } from "../models/GoalsModel";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SelectGoalType({ setSearchGoalType, defaultGoalType }) {
  const [selectedOption, setSelectedOption] = useState(defaultGoalType);

  useEffect(() => {
    setSearchGoalType(selectedOption);
  }, [selectedOption, setSearchGoalType]);

  // Adjusted for single selection
  const toggleOption = (option) => {
    if (selectedOption === option) {
      setSelectedOption(""); 
    } else {
      setSelectedOption(option); 
    }
  };

  return (
    <Listbox as="div" value={selectedOption} onChange={toggleOption}>
      {({ open }) => (
        <div className="relative">
          <Listbox.Label className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900">
            Goal Type
          </Listbox.Label>
          <Listbox.Button className="block w-[100%] text-left rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-4 h-9">
            <span className="block truncate">
              {selectedOption && (
                <div>
                  {" "}
                  {goalTypes[selectedOption].emoji}{" "}
                  {goalTypes[selectedOption].label}
                </div>
              )}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            show={open}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {Object.keys(goalTypes).map((option) => (
                <Listbox.Option
                  key={option}
                  className={({ active }) =>
                    classNames(
                      active ? "bg-indigo-600 text-white" : "text-gray-900",
                      "relative cursor-default select-none py-2 pl-3 pr-9",
                    )
                  }
                  value={option}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={classNames(
                          "block truncate",
                          selected ? "font-semibold" : "font-normal",
                        )}
                      >
                        {goalTypes[option].emoji} {goalTypes[option].label}
                      </span>
                      {selected && (
                        <span
                          className={classNames(
                            active ? "text-white" : "text-indigo-600",
                            "absolute inset-y-0 right-0 flex items-center pr-4",
                          )}
                        >
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
}
